/**
 * Glowwa FAQ Hero — Tab filter
 * Version: 1.0.0
 *
 * Wires the FAQ hero tab cards to the accordion rows in the adjacent
 * hw-faq-split section on the same page.
 *
 * How the link works:
 *   - Each tab card has data-glowwa-faq-cat="<value>" (empty = View All).
 *   - Each accordion row in hw-faq-split has data-hw-faq-category="<value>".
 *   - The two values must match exactly (case-sensitive, trimmed).
 *   - On tab click, rows whose category doesn't match get data-hw-faq-hidden
 *     set; matched rows have it deleted. hw-faq-split.css hides rows with
 *     that attribute — no extra CSS needed here.
 *
 * Dependencies: hw-faq-split.css (for [data-hw-faq-hidden] display: none rule)
 */

(function () {
  'use strict';

  /**
   * Get all filterable accordion rows on the page.
   * Scoped to .hw-faq-split so we only touch the FAQ section, not other
   * accordion components that might exist elsewhere.
   */
  function getRows() {
    return Array.from(
      document.querySelectorAll(
        '.hw-faq-split accordion-custom[data-hw-faq-category]'
      )
    );
  }

  /**
   * Show/hide accordion rows by category.
   * @param {string} category — empty string means show all.
   */
  function applyFilter(category) {
    getRows().forEach(function (row) {
      var rowCat = (row.dataset.hwFaqCategory || '').trim();
      if (category === '' || rowCat === category) {
        delete row.dataset.hwFaqHidden;
      } else {
        row.dataset.hwFaqHidden = '';
      }
    });
  }

  /**
   * Wire click handler for a hero section element.
   * Safe to call multiple times — checks for prior wiring via data attribute.
   */
  function initHero(heroEl) {
    if (heroEl.dataset.glowwaFaqWired === '1') return;
    heroEl.dataset.glowwaFaqWired = '1';

    heroEl.addEventListener('click', function (e) {
      var tab = e.target.closest('.glowwa-faq-hero__tab');
      if (!tab) return;

      // Update active state on all tabs in this hero
      heroEl.querySelectorAll('.glowwa-faq-hero__tab').forEach(function (t) {
        t.setAttribute('aria-pressed', t === tab ? 'true' : 'false');
      });

      // Filter the accordion
      applyFilter((tab.dataset.glowwaFaqCat || '').trim());
    });

    // Apply initial filter based on the tab that is active on page load.
    // Typically the first tab (View All, empty category) so all rows show.
    var activeTab = heroEl.querySelector('.glowwa-faq-hero__tab[aria-pressed="true"]');
    if (activeTab) {
      applyFilter((activeTab.dataset.glowwaFaqCat || '').trim());
    }
  }

  function init() {
    document.querySelectorAll('[data-glowwa-faq-hero]').forEach(initHero);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when either the hero section or the FAQ split
  // section reloads (editor swaps the entire section node on change).
  document.addEventListener('shopify:section:load', function (e) {
    // Hero section reloaded — re-wire it (wiring flag lives on the old node)
    e.target.querySelectorAll('[data-glowwa-faq-hero]').forEach(initHero);

    // FAQ split section reloaded — re-apply the active tab's filter so
    // the freshly-rendered accordion rows get the correct visibility state.
    if (e.target.querySelector('.hw-faq-split')) {
      var activeTab = document.querySelector(
        '[data-glowwa-faq-hero] .glowwa-faq-hero__tab[aria-pressed="true"]'
      );
      if (activeTab) {
        applyFilter((activeTab.dataset.glowwaFaqCat || '').trim());
      }
    }
  });
})();
